// Norrviva — Samples builder (page.samples template).
// Real-cart tile toggling + filter chips + fixed tray, all driven by
// window.theme.cart.store (the same store the header cart bubble already
// subscribes to). No localStorage: tile "selected" state and the tray both
// read directly from the live cart, so they also react to sample sets added
// elsewhere on the page (norrviva-samples-swipe.js) or removed via the cart
// drawer — whichever path changed the cart, this re-renders from the store.
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function formatMoney(amountCents) {
    var fmt = (window.theme && window.theme.money_format) || '{{amount}}';
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(amountCents, fmt);
    }
    return (amountCents / 100).toFixed(2);
  }

  function fillTemplate(template, vals) {
    return (template || '').replace(/\{(\w+)\}/g, function (match, key) {
      return Object.prototype.hasOwnProperty.call(vals, key) ? vals[key] : match;
    });
  }

  function getStore() {
    return window.theme && window.theme.cart && window.theme.cart.store;
  }

  ready(function () {
    var section = document.querySelector('.nvv-samples-builder');
    if (!section) return;

    var tray = section.querySelector('[data-samples-tray]');
    var trayStack = section.querySelector('[data-tray-stack]');
    var trayCount = section.querySelector('[data-tray-count]');
    var trayHint = section.querySelector('[data-tray-hint]');
    var trayCta = section.querySelector('[data-tray-cta]');
    var trayClear = section.querySelector('[data-tray-clear]');
    var ctaLabel = (trayCta && trayCta.dataset.label) || 'Order samples';
    var tiles = Array.prototype.slice.call(section.querySelectorAll('[data-samples-tile]'));
    var filters = section.querySelector('[data-samples-filters]');
    if (!tray) return;

    var tier = {
      tier1Count: Number(tray.dataset.tier1Count) || 3,
      tier1Pct: Number(tray.dataset.tier1Pct) || 10,
      tier2Count: Number(tray.dataset.tier2Count) || 5,
      tier2Pct: Number(tray.dataset.tier2Pct) || 15,
      tier2Note: tray.dataset.tier2Note || '',
      hintProgress: tray.dataset.hintProgress || '',
      hintTier1: tray.dataset.hintTier1 || '',
      hintTier2: tray.dataset.hintTier2 || '',
      countSingular: tray.dataset.countSingular || 'sample',
      countPlural: tray.dataset.countPlural || 'samples',
    };

    function sampleItems(state) {
      return (state.products.items || []).filter(function (item) {
        return item.product_type === 'Sample';
      });
    }

    function render(state) {
      var items = sampleItems(state);
      var n = items.length;
      var variantIds = items.map(function (item) { return String(item.variant_id); });

      tiles.forEach(function (tile) {
        var on = variantIds.indexOf(tile.dataset.variantId) !== -1;
        tile.dataset.on = on ? 'true' : 'false';
        tile.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      tray.dataset.open = n > 0 ? 'true' : 'false';
      document.body.dataset.samplesTrayOpen = n > 0 ? 'true' : 'false';
      if (!n) return;

      trayStack.innerHTML = '';
      items.slice(0, 7).forEach(function (item) {
        var img = document.createElement('img');
        img.src = item.image;
        img.alt = item.product_title || '';
        trayStack.appendChild(img);
      });

      trayCount.textContent = n + ' ' + (n === 1 ? tier.countSingular : tier.countPlural);

      var vals = { remaining: 0, pct: tier.tier1Pct, pct2: tier.tier2Pct, note: tier.tier2Note };
      var hint;
      if (n < tier.tier1Count) {
        vals.remaining = tier.tier1Count - n;
        hint = fillTemplate(tier.hintProgress, vals);
      } else if (n < tier.tier2Count) {
        vals.remaining = tier.tier2Count - n;
        hint = fillTemplate(tier.hintTier1, vals);
      } else {
        hint = fillTemplate(tier.hintTier2, vals);
      }
      // innerHTML is safe here: hint templates come only from merchant-authored
      // inline_richtext section settings (the <em> accent), never customer input.
      // Only write when it actually changed — the textblock is an aria-live
      // region, and rewriting identical markup can re-announce on some SRs.
      if (trayHint.innerHTML !== hint) trayHint.innerHTML = hint;

      var totalCents = items.reduce(function (sum, item) { return sum + item.final_line_price; }, 0);
      if (trayCta) trayCta.textContent = ctaLabel + ' · ' + formatMoney(totalCents);
    }

    var store = getStore();
    if (store) {
      render(store.getState());
      store.subscribe(render);
    }

    tiles.forEach(function (tile) {
      var toggle = function () {
        if (tile.dataset.busy === 'true') return;
        var s = getStore();
        if (!s) return;
        var variantId = tile.dataset.variantId;
        var state = s.getState();
        var existing = state.products.items.find(function (item) {
          return String(item.variant_id) === variantId;
        });

        tile.dataset.busy = 'true';
        var request = existing
          ? s.getState().change(existing.key, 0)
          : s.getState().add({ id: variantId, quantity: 1 });
        request
          .catch(function () {})
          .then(function () { tile.dataset.busy = 'false'; });
      };
      tile.addEventListener('click', toggle);
      tile.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle();
        }
      });
    });

    if (trayClear) {
      trayClear.addEventListener('click', function () {
        if (trayClear.dataset.busy === 'true') return;
        var s = getStore();
        if (!s) return;
        var items = sampleItems(s.getState());
        if (!items.length) return;
        // Remove every Sample-type line sequentially (change() is async; firing
        // them in parallel races the store's optimistic state). The tray
        // auto-closes when the count hits 0 via the existing render subscriber.
        trayClear.dataset.busy = 'true';
        var chain = Promise.resolve();
        items.forEach(function (item) {
          chain = chain.then(function () {
            var store = getStore();
            return store ? store.getState().change(item.key, 0) : null;
          });
        });
        chain.catch(function () {}).then(function () { trayClear.dataset.busy = 'false'; });
      });
    }

    if (filters) {
      filters.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-filter]');
        if (!btn) return;
        filters.querySelectorAll('[data-filter]').forEach(function (b) {
          b.dataset.active = b === btn ? 'true' : 'false';
        });
        var f = btn.dataset.filter;
        section.querySelectorAll('.nvv-samples-builder__pgroup').forEach(function (g) {
          g.dataset.hidden = f === 'all' || g.dataset.pattern === f ? 'false' : 'true';
        });
      });
    }
  });
})();
